var levels = require('./levels.js');
function browserRenderer(config, record) {
  function label(color) {
    return 'background-color: '+color+'; padding: 0 5px; border-radius: 2px; color: #272727; border: 1px solid rbga(0,0,0,0.8)';
  }
  function verb(color) {
    return 'padding: 0 5px; font-weight: bold; border-radius: 2px; color: '+color;
  }
  var prefixes = [record.name];
  var colors = [];
  switch(record.level) {
    case levels.DEBUG:
      prefixes[0] += ' +'+record.delay+'ms';
      colors.push(label('#DFEBB6'));
      break;

    case levels.ERROR:
      colors.push(label('#A8182A'));
      break;

    case levels.WARNING:
      colors.push(label('#FCD283'));
      break;

    default:
      colors.push(label('#BCD4E7'));
      break;
  }
  var args = record.args.slice(0);
  if (record.level==levels.INFO && record.verb) {
    prefixes.push(record.verb);
    colors.push(verb('#CB3953'));
  }
  colors.reverse().forEach(function(a) { args.unshift(a)})
  args.unshift('%c'+prefixes.join('%c'));
  console.log.apply(console, args);
}
module.exports = {
  name: 'browser',
  build: function(config) {
    return (function(config) {
      return function(log) {
        browserRenderer(config, log);
      }
    })(config);
  }
}
